import React from 'react'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import { AuditType } from './SectionSelection'

interface AuditTypeDropdownProps {
  value: AuditType | null
  onChange: (auditType: AuditType) => void
  auditTypes: Array<{ key: AuditType; label: string }>
}

export default function AuditTypeDropdown({
  value,
  onChange,
  auditTypes,
}: AuditTypeDropdownProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value as AuditType
    onChange(newValue)
  }

  return (
    <TextField
      label='Audit Type'
      select
      fullWidth
      value={value || ''}
      onChange={handleChange}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: 400,
            },
          },
        },
      }}
    >
      <MenuItem
        value=''
        disabled
      >
        Select Audit Type
      </MenuItem>
      {auditTypes.map(({ key, label }) => (
        <MenuItem
          key={key}
          value={key}
        >
          {label}
        </MenuItem>
      ))}
    </TextField>
  )
}
